import { render, staticRenderFns } from "./GlobalDialog.vue?vue&type=template&id=7f1b7f42&"
import script from "./GlobalDialog.vue?vue&type=script&lang=js&"
export * from "./GlobalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports